import { DownloadSimple } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { number } from "../shared";
import { downloadReportCsv, percent, reportColor } from "./reportUtils";

export const CtnReportSection = ({ id, title, rows, label, filters, children }) => <section className="ctn-report-section" aria-labelledby={`ctn-report-title-${id}`} data-testid={`ctn-report-group-per-${id}`}>
  <header className="ctn-report-section-header">
    <h2 id={`ctn-report-title-${id}`} data-testid={`ctn-report-title-${id}`}>{title}</h2>
    <Button size="sm" variant="outline" aria-label={`Exporteer ${label.toLowerCase()} als CSV`} onClick={() => downloadReportCsv(rows, label, id, filters)} disabled={!rows.length} data-testid={`ctn-report-csv-${id}`}><DownloadSimple size={15} /><span>Export CSV</span></Button>
  </header>
  {children}
</section>;

export const CtnReportTooltip = ({ active, payload, id, total }) => {
  if (!active || !payload?.length) return null;
  const row = payload[0].payload;
  return <div className="ctn-report-tooltip" data-testid={`ctn-report-tooltip-${id}`}><strong>{row.naam}</strong><span>{number(row.stuks)} stuks · {percent(row.stuks, total)}%</span></div>;
};

export const CtnReportLegend = ({ rows, id, total, singleColor = false }) => <ol className="ctn-report-legend" data-testid={`ctn-report-legend-${id}`}>
  {rows.map((row, index) => <li key={row.naam} data-testid={`ctn-report-per-${id}-${index}`}>
    <span className="ctn-report-legend-dot" aria-hidden="true" style={{ background: singleColor ? "#75b95a" : reportColor(index) }} />
    <span className="ctn-report-legend-name" data-testid={`ctn-report-${id}-name-${index}`}>{row.naam}</span>
    <span className="ctn-report-legend-value"><strong data-testid={`ctn-report-${id}-units-${index}`}>{number(row.stuks)} <small>stuks</small></strong><span data-testid={`ctn-report-${id}-percent-${index}`}>{percent(row.stuks, total)}%</span></span>
  </li>)}
</ol>;